import { Entry } from 'contentful'
import {
  IContentfulConfigurableTileListEntry,
  TContentfulConfigurableTileList,
} from 'types/contentful/configurableTileList.types'
import { parseConfigurableCard } from './parseConfigurableCard'
import { parseConfigurableResource } from './parseConfigurableResource'

const parseTile = (tile) => {
  const type = tile.sys?.contentType?.sys?.id
  if (type === 'configurableResource') {
    return parseConfigurableResource(tile)
  }
  if (type === 'configurableCard') {
    return parseConfigurableCard(tile)
  }
  return {}
}

export const parseConfigurableTileList = (
  configurableTileList: Entry<IContentfulConfigurableTileListEntry>
): TContentfulConfigurableTileList => {
  const tileList = {
    componentKey: 'configurableTileList',
    name: configurableTileList?.fields?.name,
    backgroundColor: configurableTileList?.fields?.backgroundColor,
    tiles: configurableTileList?.fields?.tiles?.map((tile) => parseTile(tile)),
  }
  return tileList
}
